var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVenmoScanButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 19.892,
    x: 1,
    y: 1,
    stroke: "#3172D7",
    strokeWidth: 0.432,
    rx: 9.946
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.027,
    height: 3.027,
    x: 10.513,
    y: 7.054,
    stroke: "#5593C9",
    strokeWidth: 0.432,
    rx: 0.432
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.297,
    height: 1.297,
    x: 11.378,
    y: 7.919,
    fill: "#5593C9",
    rx: 0.432
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.027,
    height: 3.027,
    x: 10.513,
    y: 11.81,
    stroke: "#5593C9",
    strokeWidth: 0.432,
    rx: 0.432
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.297,
    height: 1.297,
    x: 11.378,
    y: 12.676,
    fill: "#5593C9",
    rx: 0.432
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.297,
    height: 1.297,
    x: 14.838,
    y: 11.81,
    fill: "#5593C9",
    rx: 0.432
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1.297,
    height: 1.297,
    x: 14.837,
    y: 13.541,
    fill: "#5593C9",
    rx: 0.432
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1.297,
    height: 1.297,
    x: 16.567,
    y: 11.812,
    fill: "#5593C9",
    rx: 0.432
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1.297,
    height: 1.297,
    x: 16.567,
    y: 13.541,
    fill: "#5593C9",
    rx: 0.432
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.027,
    height: 3.027,
    x: 14.837,
    y: 7.054,
    stroke: "#5593C9",
    strokeWidth: 0.432,
    rx: 0.432
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 1.297,
    height: 1.297,
    x: 15.702,
    y: 7.919,
    fill: "#5593C9",
    rx: 0.432
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3172D7",
    d: "M24.59 13.651c1.196 0 2.046-.63 2.046-1.692 0-1.165-.937-1.456-1.771-1.707-.858-.26-.992-.433-.992-.685 0-.22.197-.417.59-.417.504 0 .764.244.953.637l1.062-.622c-.401-.81-1.11-1.243-2.015-1.243-.952 0-1.849.614-1.849 1.676 0 1.055.803 1.448 1.621 1.677.827.228 1.141.362 1.141.7 0 .213-.15.449-.747.449-.622 0-.96-.307-1.157-.764l-1.086.63c.307.81 1.047 1.361 2.203 1.361zM29.09 13.651c.77 0 1.44-.401 1.778-1.015l-1.031-.59c-.126.275-.417.44-.764.44-.511 0-.889-.37-.889-.912 0-.543.378-.913.89-.913.346 0 .63.165.763.44l1.03-.598c-.338-.606-1.014-1.007-1.778-1.007-1.196 0-2.085.905-2.085 2.078 0 1.172.889 2.077 2.085 2.077zM33.983 9.606v.37c-.26-.3-.646-.48-1.173-.48-1.031 0-1.881.905-1.881 2.078 0 1.172.85 2.077 1.88 2.077.528 0 .914-.18 1.174-.48v.37h1.18V9.606h-1.18zm-.937 2.928c-.543 0-.937-.37-.937-.96s.394-.96.937-.96.937.37.937.96-.394.96-.937.96zM38.195 9.496c-.52 0-.913.189-1.126.48v-.37h-1.18v3.935h1.18v-2.148c0-.56.3-.811.732-.811.378 0 .685.228.685.716v2.243h1.18v-2.416c0-1.062-.676-1.63-1.471-1.63z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenmoScanButton);
export default __webpack_public_path__ + "static/media/venmo-scan-button.7cbbfa143f14ecbd35dfea20f5cae14e.svg";
export { ForwardRef as ReactComponent };